// Shipping Unavailable Popup @ s4@yldress.com
// ✅ ONLY TRIGGERS WHEN "Sold out" APPEARS ON PAGE
// ✅ NO FALSE POSITIVES ON AVAILABLE ITEMS
(function () {
  const cfg = window.__SHIPPING_POPUP_CFG__;
  if (!cfg) return;

  // ✅ 唯一触发条件：页面出现【Sold out】文字
  const SEL  = '.label-unavailable, .product-form__message';
  const SOLD_OUT_TEXT = 'Sold out';

  // ✅ 只判断：是否真的出现 Sold out 文字
  function isSoldOut() {
    const elements = document.querySelectorAll(SEL);
    for (const el of elements) {
      if (el.textContent.trim().includes(SOLD_OUT_TEXT)) {
        return true;
      }
    }
    return false;
  }

  function init() {
    if (isSoldOut()) {
      buildAndShow();
      return;
    }

    const root = document.querySelector('main') || document.body;
    const obs = new MutationObserver(() => {
      if (isSoldOut()) {
        obs.disconnect();
        buildAndShow();
      }
    });

    // ✅ 最高性能：只监听节点插入，不监听属性
    obs.observe(root, {
      childList: true,
      subtree: true
    });
  }

  // ── DOM 构建（只执行一次）──────────────────────
  function buildAndShow() {
    if (document.getElementById('shipping-unavail-overlay')) {
      showPopup();
      return;
    }

    const style = document.createElement('style');
    style.id = 'shipping-popup-style';
    style.textContent = `
      #shipping-unavail-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,0.55); z-index:999999; align-items:center; justify-content:center; font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif; }
      #shipping-unavail-overlay.active { display:flex; }
      #shipping-unavail-box { background:#fff; border-radius:12px; padding:36px 32px 28px; max-width:420px; width:90%; text-align:center; box-shadow:0 8px 40px rgba(0,0,0,0.18); position:relative; }
      #shipping-unavail-box h3 { margin:0 0 12px; font-size:1.15rem; font-weight:600; color:#1a1a1a; }
      #shipping-unavail-box p  { color:#444; font-size:0.95rem; line-height:1.6; margin:0 0 20px; }
      .su-model-tag { display:none; background:#f4f4f4; border-radius:6px; padding:2px 10px; font-size:0.85rem; color:#888; margin-bottom:18px; }
      .su-btn { display:none; padding:12px 28px; border-radius:8px; font-size:1rem; font-weight:600; text-decoration:none; cursor:pointer; border:none; width:100%; margin-bottom:10px; transition:opacity 0.2s; box-sizing:border-box; }
      .su-btn:hover { opacity:0.85; }
      .su-btn-wa   { background:#25D366; color:#fff; }
      .su-btn-mail { background:#1a1a1a; color:#fff; }
      #su-countdown { font-size:0.82rem; color:#aaa; margin-top:6px; display:none; }
      #su-close { position:absolute; top:12px; right:16px; font-size:1.4rem; cursor:pointer; color:#aaa; background:none; border:none; line-height:1; padding:0; }
      #su-close:hover { color:#333; }
    `;
    document.head.appendChild(style);

    const wrap = document.createElement('div');
    wrap.innerHTML = `
      <div id="shipping-unavail-overlay" role="dialog" aria-modal="true">
        <div id="shipping-unavail-box">
          <button id="su-close" aria-label="Close">×</button>
          <h3>🚚 Item is available</h3>
          <p>Shipping hasn’t been configured for your location, reach out to us for pricing details.</p>
          <div class="su-model-tag" id="su-model"></div>
          <a id="su-wa-btn" class="su-btn su-btn-wa" target="_blank" rel="noopener">💬 WhatsApp Us</a>
          <a id="su-mail-btn" class="su-btn su-btn-mail">✉️ Email Us</a>
          <div id="su-countdown"></div>
        </div>
      </div>
    `;
    document.body.appendChild(wrap.firstElementChild);

    bindEvents();
    setTimeout(showPopup, 300);
  }

  // ── 弹窗逻辑 ──────────────────────────────────
  let timer = null;
  let shown = false;

  function inCooldown() {
    const t = localStorage.getItem(cfg.storageKey);
    if (!t) return false;
    const num = parseInt(t, 10);
    return !isNaN(num) && (Date.now() - num) < cfg.cooldown;
  }

  function showPopup() {
    if (shown || inCooldown()) return;
    shown = true;

    const model = (cfg.model || '').trim();
    const modelEl = document.getElementById('su-model');
    modelEl.textContent = model ? 'Model: ' + model : '';
    modelEl.style.display = model ? 'inline-block' : 'none';

    const hour = (new Date().getUTCHours() + 8) % 24;
    const wa = document.getElementById('su-wa-btn');
    const mail = document.getElementById('su-mail-btn');
    const cd = document.getElementById('su-countdown');

    if (hour >= 8 && hour < 22) {
      const msg = encodeURIComponent('Hi, I need a shipping quote for:\nProduct: ' + cfg.title + (model ? '\nModel: ' + model : '') + '\nURL: ' + location.href);
      wa.href = 'https://wa.me/' + cfg.waNum + '?text=' + msg;
      wa.style.display = 'block';
      mail.style.display = 'none';
      cd.style.display = 'none';
    } else {
      const subj = encodeURIComponent('Shipping Quote' + (model ? ' - ' + model : ''));
      const body = encodeURIComponent('Hi,\n\nProduct: ' + cfg.title + (model ? '\nModel: ' + model : '') + '\nURL: ' + location.href + '\n\nPlease advise shipping cost.');
      const mailto = 'mailto:' + cfg.email + '?subject=' + subj + '&body=' + body;
      mail.href = mailto;
      mail.style.display = 'block';
      wa.style.display = 'none';
      cd.style.display = 'block';
      startAutoOpen(mailto);
    }

    document.getElementById('shipping-unavail-overlay').classList.add('active');
  }

  function startAutoOpen(link) {
    let s = 10;
    const cd = document.getElementById('su-countdown');
    cd.textContent = 'Opening email in ' + s + 's...';
    timer = setInterval(() => {
      s--;
      if (s <= 0) {
        clearInterval(timer); timer = null;
        const a = document.createElement('a'); a.href = link; a.click();
      } else {
        cd.textContent = 'Opening email in ' + s + 's...';
      }
    }, 1000);
  }

  function closePopup() {
    document.getElementById('shipping-unavail-overlay').classList.remove('active');
    if (timer) clearInterval(timer);
    document.removeEventListener('keydown', onEsc);
    shown = false;
    localStorage.setItem(cfg.storageKey, Date.now());
  }

  function onEsc(e) {
    if (e.key === 'Escape') closePopup();
  }

  function bindEvents() {
    document.getElementById('su-close').addEventListener('click', closePopup);
    document.getElementById('shipping-unavail-overlay').addEventListener('click', e => {
      if (e.target.id === 'shipping-unavail-overlay') closePopup();
    });
    document.addEventListener('keydown', onEsc);
    window.addEventListener('beforeunload', () => timer && clearInterval(timer));
  }

  // 入口
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();